module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assignmenu/assignmenu.component.css
// module id = ./src/app/assignmenu/assignmenu.component.css
// module chunks = main